import {removeWindowClass} from '@app/utils/helpers';
// import {Gatekeeper} from 'gatekeeper-client-sdk';
import {BASE_URL} from '../config';
import axios from '../utils/axios';
import {fetch} from '../../src/apiFunction';

export const loginByAuth = async (email: string, password: string) => {
  const payload = {
    email,
    password
  };
  const url = BASE_URL + '/login';
  const type = 'post';
  const resp = await fetch(url, type, payload, false);
  if (resp?.status === 200) {
    localStorage.setItem('token', resp.data.token);
    removeWindowClass('login-page');
    removeWindowClass('hold-transition');
  }
  return resp;
};

export const getProfile = async () => {
  const url = BASE_URL + '/profile';
  const type = 'get';
  const token = localStorage.getItem('token');
  const resp = await fetch(url, type, null, token);
  // const resp = await axios.get(BASE_URL + '/profile');
  return resp;
};

export const updateProfile = async (data: any) => {
  console.log(data, 'data*****************33');
  const payload = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/user/update';
  const type = 'post';
  const resp = await fetch(url, type, payload, token);
  return resp;
};

export const getAllUserNames = async () => {
  const token = localStorage.getItem('token');
  const url = `${BASE_URL}/user/get-active-users`;
  const type = 'get';
  const resp = await fetch(url, type, null, token);
  return resp;
};

export const getFileExtentions = (file: any) => {
  if (file === 'png' || file === 'jpg' || file === 'jpeg') {
    return {type: 'MdImage'};
  }

  if (file === 'gif') {
    return {type: 'MdGif'};
  }

  if (file === 'mp3') {
    return {type: 'MdAudioFile'};
  }

  if (file === 'pm4' || file === 'pdf') {
    return {type: 'TbPdf'};
  }

  if (file === 'xls') {
    return {type: 'BsFileExcel'};
  }

  if (file === 'csv') {
    return {type: 'BsFiletypeCsv'};
  }

  if (file === 'zip') {
    return {type: 'BsFileZip'};
  }

  if (file === 'docx') {
    return {type: 'BsFiletypeDocx'};
  }
};

export const uploadImage = async (file: any) => {
  try {
    const token = localStorage.getItem('token');

    var formData = new FormData();
    formData.append('profile', file);
    const resp = await axios.post(BASE_URL + '/user/upload-files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${token}`
      }
    });
    console.log(resp, '************upload response**********');
    return resp;
  } catch (error) {
    console.log(error);
    return {ok: false};
  }
};

export const registerByAuth = async (email: string, password: string) => {
  const token = '';
  // const token = await Gatekeeper.registerByAuth(email, password);
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};

export const loginByGoogle = async () => {
  const token = '';
  // const token = await Gatekeeper.loginByGoogle();
  localStorage.setItem('token', token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return token;
};

export const registerByGoogle = async () => {
  const token = '';
  // const token = await Gatekeeper.registerByGoogle();
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};

export const loginByFacebook = async () => {
  // const token = await Gatekeeper.loginByFacebook();
  const token = '';
  localStorage.setItem('token', token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return token;
};

export const registerByFacebook = async () => {
  // const token = await Gatekeeper.registerByFacebook();
  const token = '';
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};
